// sh-sticky-header.js — F-300 (2026-05-27 LATE-2 · Boss approved · mobile added)
// Pure-JS sticky activation for main <header>. ALL viewports.
// body { overflow-y: auto } (Halo theme) breaks position:sticky on body's
// header child, so we use position:fixed via class toggle on scroll.
// Threshold 60px (clears top-bar even on mobile · minimal scroll budget).
// Spacer height read dynamically from header.offsetHeight on every activation
// — handles desktop 85px + mobile 70px + any custom Boss tweak transparently.
(function () {
  var THRESHOLD = 60;
  var STUCK_CLASS = 'sh-is-stuck';
  var SPACER_CLASS = 'sh-sticky-spacer';

  function init() {
    var header = document.querySelector(
      'header.hdt-section-header.hdt-header-inline'
    );
    if (!header) return;

    // Invisible spacer sibling AFTER header. Reserved height set dynamically
    // to match real header height the moment sticky activates (CLS = 0).
    var spacer = document.createElement('div');
    spacer.className = SPACER_CLASS;
    spacer.style.cssText = 'height:0;transition:none;';
    header.parentNode.insertBefore(spacer, header.nextSibling);

    // Capture height BEFORE going fixed (fixed elements still have
    // offsetHeight, but capturing pre-stick is safest)
    var lastHeight = header.offsetHeight || 70;
    var stuck = false;

    function update() {
      var should = window.scrollY > THRESHOLD;
      if (should !== stuck) {
        if (should) {
          // Re-measure right before going sticky in case responsive
          // breakpoint changed height since last capture
          lastHeight = header.offsetHeight || lastHeight;
          spacer.style.height = lastHeight + 'px';
          header.classList.add(STUCK_CLASS);
        } else {
          header.classList.remove(STUCK_CLASS);
          spacer.style.height = '0';
        }
        stuck = should;
      }
    }

    var rafScheduled = false;
    function onScroll() {
      if (rafScheduled) return;
      rafScheduled = true;
      requestAnimationFrame(function () {
        rafScheduled = false;
        update();
      });
    }

    function onResize() {
      // Re-measure on resize. If sticky, update spacer to new height.
      if (stuck) {
        lastHeight = header.offsetHeight || lastHeight;
        spacer.style.height = lastHeight + 'px';
      }
      update();
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
